import React, { Component} from 'react'
import ReactDOM from 'react-dom'
import { observer } from 'mobx-react'
import Store from './store/ProductionTableStore'
import Loading from './partials/Loading'
import TableFilter from './partials/TableFilter'
import LateOrders from './views/LateOrders'
import ListOrders from './views/ListOrders'
import ArticleOrders from './views/ArticleOrders'
import SummationHeader from './partials/SummationHeader'

import GroupedBar from '../charts/GroupedBar'
import DashStore from '../dashboard/Store/DashStore'

@observer
class ProductionTable extends Component {
    render() {
        DashStore.loadReservation(0);

        let view = null

        if (Store.loading) {
            view = <Loading />
        } else {
            if (Store.filters.selects.articles.selected !== null && Store.filters.selects.articles.selected.id !== null) {
                view = <div>
                    <ArticleOrders />
                </div>                                
            } else {
                view = <div>
                    <LateOrders />
                    <ListOrders />                
                </div>
            }
        }

        return <div className="production-table">
            <div className="production-table__filtercontainer">
                <GroupedBar chartOpt={ DashStore.reservationChart } />
                <TableFilter groupBy={ window.productionTableGroupBy } />
            </div>              
            <SummationHeader />
            { view }
        </div>
    }
}

const domContainer = document.querySelector('#production-table-app')

if (domContainer) {
    const elem = React.createElement
    ReactDOM.render(elem(ProductionTable), domContainer)
}

